<template>
  <div
    id="omq-help-container"
    class="dbc-gl-section dbc-c-omq-faq"
    data-js="dbc-js-omq-faq"
    :data-omq-help-account="content.account_name"
    :data-omq-help-api-key="content.account_api_key"
  />
</template>

<script setup lang="ts">
const props = defineProps<{
  content: ContentOmq
}>()

onMounted(() => {
  addExternalScript(props.content.account_script_url, 'omq')
})
</script>
